import { render } from "./SingleCta.vue?vue&type=template&id=6d88cc7d&scoped=true"
import script from "./SingleCta.vue?vue&type=script&lang=js"
export * from "./SingleCta.vue?vue&type=script&lang=js"

import "./SingleCta.vue?vue&type=style&index=0&id=6d88cc7d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d88cc7d"]])

export default __exports__